<template>
    <div>
        <div class="aFlex fchart-box-top">
            <span class="ft-bold">工资发放情况统计（默认近12个月）</span>
            <div class="aFlex">
                <DatePicker type="month" placement="bottom-end" placeholder="选择开始月份"
                            :value="startMonth" :clearable="true" transfer
                            style="width: 140px; margin-left: 16px"
                            @on-change="onStartMonth" :options="{ disabledDate: disabledDateS }"></DatePicker>
                <span style="margin: 0 4px"> ~ </span>
                <DatePicker type="month" placement="bottom-end" placeholder="选择结束月份"
                            :value="endMonth" :clearable="true" transfer
                            style="width: 140px;" :options="{ disabledDate: disabledDateE }"
                            @on-change="onEndMonth" ></DatePicker>
                <Select style="width: 160px; margin-left: 16px" v-model="areaCode" @on-change='areaChange' placeholder="选择地区" clearable transfer>
                    <Option v-for="item in area" :value="item.value" :key="item.value" >{{ item.label }}</Option>
                </Select>
            </div>
        </div>
        <div class="fchart-bi" ref="salaryBar">工资发放情况统计</div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        name: "salaryBar",
        data() {
            return {
                // 工资发放统计
                salaryBar:null,
                startMonth: '',
                endMonth: '',
                areaCode: '',
            }
        },
        computed: {
            ...mapState(['area']),
        },
        props: {

        },
        mounted() {
            //引入echarts 初始化图标
            let echarts = require('echarts');
            // 工资发放情况
            this.salaryBar = echarts.init(this.$refs.salaryBar);
            //初始化 setOption
            this.initChart();
            //获取数据
            this.getData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            disabledDateS (date) {
                // return new Date(this.endMonth || '').getTime() - 2505600000 < date.valueOf()
                return new Date(this.endMonth || '').getTime() < date.valueOf()
            },
            disabledDateE (date) {
                // return new Date(this.endMonth || '').getTime() - 2505600000 < date.valueOf()
                return new Date(this.startMonth || '').getTime() - 2505600000 > date.valueOf()
            },
            // echarts 适应
            resize(){
                this.salaryBar.resize();
            },
            initChart(){
                this.salaryBar.setOption(
                    {
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'center',
                            icon:'rect',
                        },
                        tooltip: {
                            // trigger: 'item',
                            // formatter: '{a}\n {b}: {c}',
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid:{
                            left: 60,
                            right:30,
                            top: 40,
                            // bottom: 5,
                        },
                        xAxis:{
                            name:'月份',
                            nameTextStyle:{
                                align:'right',
                                padding:[30,30,0,0]
                            },
                            /* 类目轴*/
                            type:'category',
                            axisLabel:{
                                interval:0,
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            data:[],
                        },
                        yAxis:{
                            // name:'单位: 万元',
                            nameTextStyle:{
                                align:'right',
                                // padding:[0]
                            },
                            splitLine: {
                                show: true, //网格线开关
                                lineStyle:{
                                    type:'dashed'
                                }
                            },
                            axisLine:{
                                show: false
                            },
                            minInterval: 1,
                        },
                        color: [ '#3399FF','#61DDAA','#65789B','#F6BD16'],
                        series: [
                            {
                                type: 'bar',
                                name: '出勤人数(人)',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                            {
                                type: 'bar',
                                name: '发放工资(万元)',
                                // barGap:'10%',
                                barCategoryGap: '10%',
                                barMaxWidth: 14,
                                barMinWidth: 14,
                                data:[],
                            },
                        ]
                    }
                );
            },
            areaChange(val) {
                this.getData();
            },
            onStartMonth(e){
                this.startMonth = e;
                if(this.startMonth && this.endMonth) {
                    this.getData();
                }
            },
            onEndMonth(e){
                this.endMonth = e;
                if(this.startMonth && this.endMonth) {
                    this.getData();
                }
            },
            // 工资发放情况统计-柱状图
            getData(){
                this.salaryBar.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/queryPayOffList',
                    data:{
                        areaCode:this.areaCode,
                        startMonth:this.startMonth,
                        endMonth:this.endMonth,
                    }
                }).then( (response)=> {
                    this.salaryBar.hideLoading();
                    let xData=[];
                    if (response.data){
                        response.data.salary.forEach(item=>{
                            xData.push(item.name)
                        });
                        this.salaryBar.setOption(
                            {
                                xAxis:{
                                    data: xData,
                                },
                                series:[
                                    {
                                        data: response.data.attendance,
                                    },
                                    {
                                        data: response.data.salary,
                                    }
                                ]
                            }
                        );
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
